import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import useWebhooks from '@/hooks/useWebhooks';
import { updateAction } from '@/redux/nodes/actions';
import { selectBrainId } from '@/redux/session/selectors';
import { WebhookAction } from '@/shared/types/action';

const Webhook = ({ action }: { action: WebhookAction }) => {
  const { t } = useTranslation();
  const brainId = useSelector(selectBrainId);
  const dispatch = useDispatch();
  const { actionWebhooks = [] } = useWebhooks(brainId);
  const webhookId = action.webhook_id;
  // Available webhooks
  const options = actionWebhooks.map(({ webhook_id, name }) => ({
    value: webhook_id,
    label: name,
  }));

  const onWebhookChange = useCallback(
    (value: string) => {
      dispatch(updateAction({ actionId: action.action_id, action: { webhook_id: value } }));
    },
    [action.action_id, dispatch]
  );

  return (
    <Select onValueChange={onWebhookChange} value={webhookId ?? ''}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder={t('dialog.select_a_webhook')} />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default Webhook;
